(function(){
  /* site-wide fonts: Playfair Display for headings, Outfit for everything else, form controls inherit */
  var s=document.createElement('style');
  s.textContent='body{font-family:Outfit,system-ui,sans-serif}button,input,select,textarea{font-family:inherit}h1,h2,h3{font-family:"Playfair Display",Georgia,serif}';
  document.head.appendChild(s);
})();
(function(){
  /* desktop filter sidebar: every group open by default on every page */
  if(innerWidth<1024)return;
  var kf=document.querySelector('[data-kf]');if(!kf)return;
  var n=0,t=setInterval(function(){
    var b=kf.querySelector('.kf__g:not(.open) .kf__gh');
    if(b){b.click()}
    else if(kf.querySelector('.kf__g')||++n>60){clearInterval(t)}
  },150);
})();
(function(){
  var m=document.querySelector('.kbs-m');
  if(!m||document.querySelector('.kbch'))return;
  var p=location.pathname.replace(/\/+$/,'')||'/';
  if(/\/products\//.test(p)||/^\/(cart|checkout|account)/.test(p))return;
  var ar=!!(window.KBS&&KBS.ar);
  var L=[
    ['BEST','الأكثر مبيعاً','/collections/best-sellers'],
    ['NEW','جديد','/collections/new-arrivals'],
    ['PDRN','PDRN','/collections/pdrn'],
    ['BUNDLES & SETS','الباندلز والسيتات','/collections/sets-gifts'],
    ['HAIR','الشعر','/collections/hair-care'],
    ['BRANDS','البراندات','/pages/brands']
  ];
  var css='.kbch{display:none}@media(max-width:1023px){.kbch{display:flex;gap:8px;padding:10px 14px 12px;overflow-x:auto;scrollbar-width:none;background:#fff;-webkit-overflow-scrolling:touch}.kbch::-webkit-scrollbar{display:none}.kbch a{flex:none;border:1px solid #0D0D0D;border-radius:99px;padding:10px 18px;font:600 12px/1 Outfit,sans-serif;letter-spacing:'+(ar?'0':'.12em')+';color:#0D0D0D;background:#fff;text-decoration:none;transition:transform .15s,background .15s}.kbch a:active{transform:scale(.96)}.kbch a.on{background:#0D0D0D;color:#fff}}';
  var st=document.createElement('style');st.textContent=css;document.head.appendChild(st);
  var n=document.createElement('nav');n.className='kbch';n.setAttribute('aria-label','Quick links');
  L.forEach(function(x){
    var a=document.createElement('a');a.href=(ar?'/ar':'')+x[2];a.textContent=ar?x[1]:x[0];
    if(p.replace(/^\/ar(?=\/|$)/,'')===x[2])a.className='on';
    n.appendChild(a);
  });
  var h=m.closest('.shopify-section')||m;
  h.parentNode.insertBefore(n,h.nextSibling);
})();
(function(){
  /* brand pages: banner shade, square centred product images, mobile logo overlap, white-out grey photo backgrounds */
  if(!document.querySelector('.kbp__ban,.kbp__k'))return;
  var c='.kbp .kbp__ki{aspect-ratio:1/1!important}.kbp .kbp__ki img{padding:18px!important;object-fit:contain!important;object-position:center!important}@media(max-width:1023px){.kbp .kbp__hd{align-items:flex-start!important;margin-top:-40px!important}.kbp .kbp__lg{width:84px!important;height:84px!important}.kbp .kbp__hm{padding-top:46px!important}}';
  if(document.querySelector('.kbp__ban'))c+='.kbp#kbp-top{position:relative}.kbp#kbp-top:has(.kbp__ban)::before{content:"";position:absolute;top:0;left:0;right:0;aspect-ratio:1850/550;z-index:1;pointer-events:none;background:linear-gradient(180deg,rgba(13,13,13,.18) 0%,rgba(13,13,13,.14) 50%,rgba(13,13,13,.34) 100%)}.kbp#kbp-top .kbp__hd{z-index:2}';
  var st=document.createElement('style');st.textContent=c;document.head.appendChild(st);
  function fix(i){
    if(i.__w)return;i.__w=1;
    try{
      var cv=document.createElement('canvas');cv.width=cv.height=40;
      var x=cv.getContext('2d',{willReadFrequently:true});x.drawImage(i,0,0,40,40);
      var v=[[1,1],[37,1],[1,37],[37,37]].map(function(q){var d=x.getImageData(q[0],q[1],2,2).data;return(d[0]+d[1]+d[2])/3}).sort(function(a,b){return a-b});
      var lo=(v[0]+v[1])/2;
      if(lo<247&&lo>140&&v[3]-v[0]<90){i.style.filter='brightness('+Math.min(1.22,255/lo).toFixed(3)+') contrast(1.14)'}
    }catch(e){}
  }
  function run(){document.querySelectorAll('.kbp .kbp__ki img').forEach(function(i){
    if(i.complete&&i.naturalWidth)fix(i);else i.addEventListener('load',function(){fix(i)},{once:true});
  })}
  run();setTimeout(run,1200);
})();
